import { useGlobalStream, useKeywordMetadata, useServiceAppState } from '../../hooks';

const SERVICE_NAME = 'stream';
const ENDPOINT_KEY = 'kc-stream';

const StreamInitializer = () => {
  const {
    state: { region, language },
  } = useServiceAppState();

  const { data: metadata } = useKeywordMetadata(SERVICE_NAME, region);

  const endpoint = metadata?.endpoints[ENDPOINT_KEY];
  // notificationRelevance(mine) / includeGlobalNotifications(true)는 서버 기본값을 따른다 —
  // 도메인 스콥(project context 없음)에서도 global notification 채널이 구독되어 새소식이 유지된다.
  const streamUrl = endpoint ? `${endpoint}/v1/stream/streams?language=${language}` : undefined;

  useGlobalStream({
    streamUrl,
    autoConnect: Boolean(streamUrl),
  });

  return null;
};

export default StreamInitializer;
